import { Card, CardContent, CardHeader } from "@mui/material";
import type { JSX } from "react";

import { AvatarUploader } from "../../../components/AvatarUploader.js";
import type { ProfileUser } from "./profileTypes.js";

/** Profile photo card — the avatar uploader, posting to `/api/profile/avatar`.
 * Extracted from `ProfilePage.tsx`. */
export function AvatarCard({
  user,
  onSaved,
}: {
  user: ProfileUser;
  onSaved: () => void;
}): JSX.Element {
  const display =
    user.full_name?.trim() ||
    [user.first_name, user.last_name].filter(Boolean).join(" ").trim() ||
    user.email;
  return (
    <Card>
      <CardHeader title="Photo" />
      <CardContent>
        <AvatarUploader
          userId={user.id}
          name={display}
          endpoint="/api/profile/avatar"
          onUploaded={onSaved}
        />
      </CardContent>
    </Card>
  );
}
